import { UIHeading2, UIText2 } from '@cian/ui-kit';
import * as React from 'react';

import { WrapContainer } from '../WrapContainer';
import { TUser } from '../../types/user';

import * as styles from './styles.css';

export interface IResultsEmptyProps {
  user: TUser;
}

export const ResultsEmptyV2: React.FC<IResultsEmptyProps> = () => {
  return (
    <WrapContainer>
      <div className={styles['content']}>
        <div className={styles['background']} />
        <div className={styles['title']}>
          <UIHeading2>Добавляйте объявления в&nbsp;избранное</UIHeading2>
        </div>
        <UIText2>Отмечайте интересные объявления и&nbsp;следите за&nbsp;изменением цены</UIText2>
      </div>
    </WrapContainer>
  );
};
